<template>
    <div class="order-item">
        <div class="order-item-head">
            <div>房源订单</div>
            <div class="ml-a">下单时间：{{item.updated_at}}</div>
            <!--<div class="ml-a color-red">item</div>-->
        </div>
        <div class="order-body">
            <!--<img class="order-body-img" :src="`/api/v1/file/${item.driver_portrait}`" alt="">-->
            <div class="order-content">
                <el-form label-width="100px" label-position="right">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;" label="订单编号：">{{item.coding}}</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="房源名称：">{{item.title_true}}</el-form-item>
                            <el-form-item v-if="item.flight" style="margin-bottom: 0;" label="航班号：">{{item.flight}}
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="入住时间：">
                                {{item.check_in_time.substr(0, 10)}}
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="退房时间：">
                                {{item.check_out_time.substr(0, 10)}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;" label="预约用户：">
                                {{item.user_name}}
                                <el-link class="ml-10" type="primary" @click="handlerLink" :underline="false">联系TA</el-link>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="人数：">{{item.num}}人</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="金额：">
                                <span class="color-red">{{+item.all_price|parseMoney}}</span>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="留言备注：">{{item.remarks}}</el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="order-btn">
                <el-button v-if="item.order_state === 1" size="mini" @click="landlordAcceptOrder" type="success">接受预约</el-button>
                <el-button v-if="item.order_state === 1" size="mini" @click="landlordCancelOrder" type="warning">拒绝预约</el-button>
                <el-button v-if="item.order_state === 4" size="mini" @click="$emit('feedback')" type="warning">投诉TA</el-button>
                <el-button v-if="item.order_state === 4" size="mini" @click="$emit('evaluate')" type="success">评价TA</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {delToast} from './../utlis/decorators'
    export default {
        name: "OrderHouseLandlord",
        props: {
            item: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        methods: {
            @delToast('是否接受预约？')
            async landlordAcceptOrder() {
                let [e, data] = await this.$api.landlordAcceptOrderApi({
                    id: this.item.id,
                    accept: 1
                })
                if(data.status){
                    this.$emit('refreshOrder')
                }
            },
            @delToast('是否拒绝预约？')
            async landlordCancelOrder() {
                let [e, data] = await this.$api.landlordAcceptOrderApi({
                    id: this.item.id,
                    accept: 2
                })
                if(data.status){
                    this.$emit('refreshOrder')
                }
            },
            handlerLink() {
                this.$store.commit('initChartData', {
                    id: this.item.user_id,
                    info: {
                        nickname: this.item.user_name,
                        avar: 102,
                    }
                })
                this.$eventBus.$emit('openChart', {
                    id: this.item.user_id,
                    name: this.item.user_name
                })
            },
        },
    }
</script>

<style scoped lang="less">
    .order-item {
        border-radius: 6px;
        overflow: hidden;
        margin-bottom: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

        .order-item-head {
            width: 100%;
            height: 44px;
            background-color: #f5f5f5;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 20px;
            font-size: 14px;
            box-sizing: border-box;
        }

        .order-body {
            padding: 20px;
            box-sizing: border-box;
            background-color: #ffffff;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;

            .order-body-img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                border-radius: 6px;
                margin-right: 20px;
            }
        }

        .order-content {
            flex: 1;
            height: 100%;
        }

        .order-btn {
            width: 200px;
            margin-top: auto;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>

